import userReducer from "./userSlice";

export default userReducer;
